var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_3420_1204_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.90735e-10 -0.00436364 0.00436351 -1.90741e-10 8.0139 8)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2065.75,
    y: -2065.75,
    width: 4131.5,
    height: 4131.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(160, 126, 255, 1) 0deg,rgba(0, 0, 0, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-05 8C-3.8147e-05 3.58172 3.58158 -1.93129e-07 7.99974 0C12.4179 1.93129e-07 15.9995 3.58172 15.9995 8C15.9995 12.4183 12.4179 16 7.99974 16C3.58158 16 -3.91006e-05 12.4183 -3.8147e-05 8Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.62770730257034302,\"g\":0.49441730976104736,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.62770730257034302,\"g\":0.49441730976104736,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-3.8147064174154366e-07,\"m01\":8.7270269393920898,\"m02\":3.6503825187683105,\"m10\":-8.7272720336914062,\"m11\":-3.8148107250890462e-07,\"m12\":12.363635063171387},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64312 6.64335C7.54814 5.7383 8.00065 4.63526 8.00065 3.33425C8.00065 4.63526 8.45317 5.7383 9.35819 6.64335C10.2632 7.5484 11.3662 8.00092 12.6672 8.00092C11.3662 8.00092 10.2632 8.45345 9.35819 9.3585C8.45317 10.2635 8.00065 11.3666 8.00065 12.6676C8.00065 11.3666 7.54814 10.2635 6.64312 9.3585C5.73809 8.45345 4.63509 8.00092 3.33412 8.00092C4.63509 8.00092 5.73809 7.5484 6.64312 6.64335Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_3420_1204_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-05 8C-3.8147e-05 3.58172 3.58158 -1.93129e-07 7.99974 0C12.4179 1.93129e-07 15.9995 3.58172 15.9995 8C15.9995 12.4183 12.4179 16 7.99974 16C3.58158 16 -3.91006e-05 12.4183 -3.8147e-05 8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrionLogo);
export default __webpack_public_path__ + "static/media/Orion Logo.11655dd606db018f9c546f7b22b54eaa.svg";
export { ForwardRef as ReactComponent };